import { fork } from "redux-saga/effects";
import watchScheduleReports from "./components/schedule_report/sagas";

const watchSchedule = [
  fork(watchScheduleReports),
];

export { watchSchedule };
